// extracted by mini-css-extract-plugin
export default {"slider-column":"auth-page_slider-column__4iPJ1"};